import { FTS_0019_GROUP_PARAMETER_KEY, FTS_0019_GROUP_PARAMETER_OPTIONS, FTS_0019_TREATMENT_KEY } from '../../constants/experimentKeys';
import { useGlobalLoading } from '../../hooks/loadingHooks';
import { useAppSelector } from '../../reducers';
import { isAppAuthSelector } from '../../selectors/AuthSelectors';
import { hasExperimentsFetchSucceededSelector } from '../../selectors/ExperimentSelectors';
import { isUngatedForSeatsSelector } from '../../selectors/GatingSelectors';
import { useIsFreePortal } from '../../v2/hooks/useProductInventory';
import { getIsAcceptanceTest } from '../testUtils';
import { logExperimentExposure, useExperimentEffect } from './experimentUtils';
const treatmentKey = FTS_0019_TREATMENT_KEY;
export const logFTS0019Exposure = () => {
  logExperimentExposure(treatmentKey);
};
const useFTS0019EligibilityCondition = () => {
  const isAcceptanceTest = getIsAcceptanceTest();
  const hasExperimentsFetchSucceeded = useAppSelector(hasExperimentsFetchSucceededSelector);
  const isAppReady = useGlobalLoading();
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const isInApp = useAppSelector(isAppAuthSelector);

  // for free & seats customers viewing in-app pricing pages
  const isConditionMet = isAppReady && hasExperimentsFetchSucceeded && !isInventoryLoading && !isAcceptanceTest && isUngatedForSeats && isFreePortal && isInApp;
  return {
    isConditionMet
  };
};
export const useFTS0019ExperimentEffect = () => useExperimentEffect({
  treatmentKey: FTS_0019_TREATMENT_KEY,
  groupParameterKey: FTS_0019_GROUP_PARAMETER_KEY,
  groupParameterOptions: FTS_0019_GROUP_PARAMETER_OPTIONS,
  experimentEligibilityCondition: useFTS0019EligibilityCondition,
  shouldLogExposure: true
});